export default __webpack_public_path__ + "static/media/alphaLion.f3283325.png";